import { render, staticRenderFns } from "./UserBlock.vue?vue&type=template&id=59655342"
import script from "./UserBlock.vue?vue&type=script&lang=js"
export * from "./UserBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports